import { Navigate, Outlet } from 'react-router-dom';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

import { Button } from '@oysterjs/ui/button';

import { SubscriptionEntitlement } from '~/api/graphql';
import { useEntitlements } from '~/components/entitlements';
import { FEATURE_FLAGS, useFlag } from '~/components/feature-flags';

export const MailboxUpgradeNotice = () => (
  <div className="divide-y divide-neutral-200 dark:divide-neutral-700 rounded-lg bg-white dark:bg-neutral-800 shadow">
    <div className="px-4 py-5 sm:px-6">
      <h3 className="m-0 p-0 text-lg font-medium text-neutral-900 dark:text-white">Mailboxes</h3>
    </div>
    <div className="px-4 py-5 sm:px-6">
      <div className="text-center">
        <EnvelopeIcon className="mx-auto size-12 text-neutral-400 dark:text-neutral-500" />
        <h3 className="mt-2 text-sm font-semibold text-neutral-900 dark:text-white">
          Mailboxes are available on the Pro plan and above
        </h3>
        <p className="mx-auto mt-1 max-w-2xl text-sm text-neutral-500 dark:text-neutral-400">
          Connect your mailbox to send emails from Cara, save drafts to your mailbox, and share
          mailbox access with your team.
        </p>
      </div>
      <div className="mt-6 flex flex-wrap justify-center gap-2">
        <Button color="sky" href="/app/settings/subscription">
          Upgrade to Pro
        </Button>
        <Button color="white" href="https://meetings.hubspot.com/vic-yeh" target="_blank">
          Contact Sales
        </Button>
      </div>
    </div>
  </div>
);

/**
 * Keep the upgrade notice reachable through Settings and bookmarked mailbox
 * URLs. An empty ledger after a downgrade would otherwise look like data loss.
 */
export const MailboxGuard = ({ to }: { to: string }) => {
  const enabled = useFlag(FEATURE_FLAGS.MAILBOX);
  const { hasEntitlement } = useEntitlements();
  if (!enabled) return <Navigate to={to} replace />;
  if (!hasEntitlement(SubscriptionEntitlement.Mailboxes)) return <MailboxUpgradeNotice />;
  return <Outlet />;
};
